import Markdown from "markdown-to-jsx";
import React from "react";
import { twMerge } from "tailwind-merge";
import { ContentBlockCustomerLogosDefaultType } from "../../../types/blocks";
import Image from "../../atoms/image";
import Link from "../../atoms/link";

const CustomerLogosDefault = ({
  headline,
  logos,
  block_settings: { background_color, html_id } = {
    background_color: "bg-white dark:bg-secondary-900",
  },
}: Omit<ContentBlockCustomerLogosDefaultType, "type">) => {
  return (
    <section className={twMerge(background_color, "scroll-mt-20")} id={html_id}>
      <div className="max-w-screen-xl px-4 py-8 mx-auto lg:py-16">
        <h2 className="mb-8 text-3xl font-extrabold leading-tight tracking-tight text-center text-secondary-900 lg:mb-16 dark:text-white md:text-4xl">
          <Markdown>{headline}</Markdown>
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16 text-secondary-500 dark:text-secondary-400">
          {logos.map((logo, logoIndex) =>
            logo.target ? (
              <Link
                to={logo.target}
                className="flex items-center justify-center transition-all duration-300 opacity-50 hover:opacity-100"
                key={logoIndex}
              >
                <Image image={logo.image} alt={logo.target} />
              </Link>
            ) : (
              <div
                className="flex items-center justify-center transition-all duration-300 opacity-50 hover:opacity-100"
                key={logoIndex}
              >
                <Image image={logo.image} alt={logo.target} />
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default CustomerLogosDefault;
